import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation/blog",
  "use": "navigation/blog-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"navigation/blog\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 2.003a1 1 0 0 1 0-2h10a1 1 0 1 1 0 2H3zm9.5 1h-9a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-7a1.5 1.5 0 0 0-1.5-1.5zm-8.5 8v-6h8v6H4zm-2 4a1 1 0 0 0 1 1h10a1 1 0 0 0 0-2H3a1 1 0 0 0-1 1z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol